module.exports = __webpack_public_path__ + "img/ic_renzhengfangshi.c20704e0.svg";